// extracted by mini-css-extract-plugin
export default {"row":"UWTableRows_row__0Cbwi","bold":"UWTableRows_bold__NhXon","borderTop":"UWTableRows_borderTop__TCT28"};